import Vue from 'vue'
import client from '@/api/client'
import filterPageItemsQuery from '@/api/gql/filter-page/query/filter-page-items.gql'
import filterPageItemRecommendationsQuery from '@/api/gql/filter-page/query/filter-page-item-recommendations.gql'
import { formatTags, formatVariants } from '@/components/FilterPage/transformation-helpers'

export const RECOMMENDATION_BLOCK_IDS = {
  miniCart: 'mini-cart',
  productPage: 'product-page',
}

export function fetchFilterPageItemRecommendations(args) {
  const options = args.skus
    ? {
        query: filterPageItemsQuery,
        variables: { skus: args.skus },
      }
    : {
        query: filterPageItemRecommendationsQuery,
        variables: { excludeProductId: args.excludeProductId },
      }
  return client.query(options).then(({ data }) => {
    const filterPageItems = data.filterPageItems || data.filterPageItemRecommendations
    return filterPageItems.map(item => formatVariants(formatTags(item)))
  })
}

function setStateProperty(state, property, payload) {
  state[property] = { ...state[property], ...payload }
}

function getStateById(state, id) {
  return {
    headline: state.headline[id] || '',
    skus: state.skus[id] || [],
    items: state.items[id] || [],
    isActive: state.isActive[id] || false,
    isLoaded: state.isLoaded[id] || false,
    isInitialisedByDy: state.isInitialisedByDy[id] || false,
  }
}

export default {
  namespaced: true,
  state: {
    headline: {},
    skus: {},
    items: {},
    isActive: {},
    isLoaded: {},
    isInitialisedByDy: {},
  },

  mutations: {
    // headline, skus and isInitialisedByDy are set from the DY recommendation widget
    setState(state, payload) {
      if (!payload.id) return

      for (const property in payload) {
        if (state[property]) Vue.set(state[property], payload.id, payload[property])
      }
    },

    setHeadline(state, payload) {
      setStateProperty(state, 'headline', payload)
    },

    setSkus(state, payload) {
      setStateProperty(state, 'skus', payload)
    },

    setIsActive(state, payload) {
      setStateProperty(state, 'isActive', payload)
    },

    setIsLoaded(state, payload) {
      setStateProperty(state, 'isLoaded', payload)
    },
  },

  actions: {
    fetchData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        if (!On.DynamicYield.shouldUpdateRecommendation) return resolve(null)

        commit('setIsLoaded', { [payload.id]: false })
        const args = payload.skus?.length
          ? { skus: payload.skus }
          : { excludeProductId: payload ? payload.excludeProductId : null }

        fetchFilterPageItemRecommendations(args)
          .then(items => {
            commit('setState', {
              id: payload.id,
              items,
              isLoaded: true,
            })
            resolve(items)
          })
          .catch(error => reject(error))
      })
    },

    fetchProductPageRecommendations({ commit, dispatch }, payload) {
      const id = RECOMMENDATION_BLOCK_IDS.productPage
      commit('setIsActive', { [id]: true })

      return dispatch('fetchData', {
        id,
        skus: payload.skus,
        excludeProductId: payload.excludeProductId,
      })
    },
  },

  getters: {
    productPageState: state => getStateById(state, RECOMMENDATION_BLOCK_IDS.productPage),
  },
}
